var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PurchaseV2',{ref:"purchaseComponent"}),_c('LeaveConfirmationDialog',{attrs:{"is-opened":_vm.isLeaveConfirmationDialogOpen},on:{"dialog:confirm":_vm.confirmLeave,"dialog:close":_vm.closeLeaveConfirmationDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }